import './news.css';
import { Article } from '../../../types/interfaces';
import urlToImageDefault from '../../../img/news_placeholder.webp';

const urlToImageDefaultPath = urlToImageDefault.split('/').slice(-2).join('/');

export class News {
    draw(data: Array<Article>):void {
        const fragment = document.createDocumentFragment();
        const newsItemTemp = document.querySelector('#newsItemTemp') as HTMLTemplateElement;

        data.forEach((item, idx):void => {
            const newsClone = newsItemTemp.content.cloneNode(true) as DocumentFragment;

            if (idx % 2) {
              (newsClone.querySelector('.news__item') as HTMLTemplateElement).classList.add('alt');
            }
            const photo = newsClone.querySelector('.news__meta-photo') as HTMLTemplateElement;
            photo.style.backgroundImage = `url(${
                item.urlToImage || urlToImageDefaultPath
            })`;
            if (photo.style.backgroundImage === `url("${urlToImageDefaultPath}")`) {
                photo.style.backgroundSize = 'contain';
            }
            (newsClone.querySelector('.news__meta-author') as HTMLTemplateElement).textContent = item.author || item.source.name;
            const publishedAt = item.publishedAt.slice(0, 10).split('-').reverse().join('-');
            (newsClone.querySelector('.news__meta-date') as HTMLTemplateElement).textContent = publishedAt;

            (newsClone.querySelector('.news__description-title') as HTMLTemplateElement).textContent = item.title;
            (newsClone.querySelector('.news__description-source') as HTMLTemplateElement).textContent = item.source.name;
            (newsClone.querySelector('.news__description-content') as HTMLTemplateElement).textContent = item.description;
            (newsClone.querySelector('.news__read-more a') as HTMLTemplateElement).setAttribute('href', item.url);

            fragment.append(newsClone);
        });

        (document.querySelector('.news') as HTMLTemplateElement).innerHTML = '';
        (document.querySelector('.news') as HTMLTemplateElement).appendChild(fragment);
    }
}